export default "__VITE_ASSET__BVBwQTgK__"